import React from 'react';
import { Loading } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { Navigate } from '@tanstack/react-router';
import { useSnackbar } from 'notistack';
import { useAvContext } from '../context/AvContextProvider';
import { APP_PATHS, PAGE_PATHS, PUBLIC_APPS } from '../types';
import { useAccountId } from '../utils/router.utils';
import { useGetStatuses } from '../views/Settings/TicketStatuses/hooks';

interface Props {
  isAllowed?: boolean;
  children?: any;
}
const ProtectedRoute: React.FC<Props> = ({ isAllowed, children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { isLoading: isLoadingStatuses } = useGetStatuses();
  const { isLoading, user, selectedApp, getPathName, enabledApps } = useAvContext();
  const accountId = useAccountId();
  const appPermission = enabledApps.some(({ id }) => id === selectedApp) || PUBLIC_APPS.includes(selectedApp);
  if (
    ([APP_PATHS.VULNERABILITIES, APP_PATHS.DETECTIONS, APP_PATHS.INCIDENTS, APP_PATHS.RISK360, APP_PATHS.ASSETS].includes(selectedApp) &&
      isLoadingStatuses) ||
    isLoading ||
    (!user.roleId && !user.roleName) ||
    !selectedApp ||
    selectedApp === ''
  ) {
    return (
      <Box sx={flex.colCenter}>
        <Loading />
      </Box>
    );
  }
  if (!isAllowed || !appPermission) {
    enqueueSnackbar("You don't have access to this page", { variant: 'warning' });
    if (!appPermission) {
      return <Navigate to={getPathName(PAGE_PATHS.SOURCES, '', APP_PATHS.PLATFORM).to} />;
    }
    return <Navigate from="/" to="/$accountId" params={accountId} />;
  }
  return children;
};

export default ProtectedRoute;
